export const StatusDescriptions: { [key: string]: string } = {
  ACTIVE:
    'A Listing/Rental Agreement is in place. The property is available for showings, and has no accepted Agreement of Sale/Signed Lease.',
  'ACTIVE UNDER CONTRACT':
    'Listing has an Agreement of Sale with contingencies or a rental application has been received. Property is available to show and accept backup offers or additional applications.',
  CANCELED:
    'Seller/Landlord and listing broker have terminated the Listing Agreement prior to its expiration date.',
  CLOSED:
    'Settlement has concluded, or the lease agreement has been signed and deposits have been collected.',
  'COMING SOON':
    'The property may be marketed and the listing is being prepared for showings, no showings are allowed while in Coming Soon status.',
  PENDING:
    'Listing has an accepted contract (Agreement of Sale) or pending lease agreement and has not closed. Seller/Landlord does not want showings or backup contracts/applications.',
  'TEMP OFF MARKET':
    'Seller/Landlord has requested that showings be temporarily suspended.',
  WITHDRAWN:
    'Marketing has ceased, but the Listing Agreement is still in effect.',
  // Add more descriptions as needed
};
